import { render, staticRenderFns } from "./ModalActivateReservations.vue?vue&type=template&id=bc2accfa"
import script from "./ModalActivateReservations.vue?vue&type=script&lang=js"
export * from "./ModalActivateReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports